"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryReader = void 0;
const Util_1 = require("../../../../Util");
class BinaryReader {
    static async fromBlob(blob) {
        const arrayBuffer = await blob.arrayBuffer();
        return new BinaryReader(arrayBuffer);
    }
    constructor(buffer) {
        this.offset = 0;
        if (ArrayBuffer.isView(buffer)) {
            this.view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
        }
        else {
            this.view = new DataView(buffer);
        }
    }
    readUint8() {
        const value = this.view.getUint8(this.offset);
        this.offset += 1;
        return value;
    }
    readUint16LE() {
        const value = this.view.getUint16(this.offset, true);
        this.offset += 2;
        return value;
    }
    readUint32LE() {
        const value = this.view.getUint32(this.offset, true);
        this.offset += 4;
        return value;
    }
    readInt32LE() {
        const value = this.view.getInt32(this.offset, true);
        this.offset += 4;
        return value;
    }
    readFloat64LE() {
        const value = this.view.getFloat64(this.offset, true);
        this.offset += 8;
        return value;
    }
    readBytes(length) {
        if (length < 0) {
            throw new Error(`[ReadBytes_InvalidLength] Cannot read negative length: ${length}`);
        }
        if (this.offset + length > this.view.byteLength) {
            throw new Error(`[ReadBytes_OutOfBounds] Cannot read ${length} bytes at offset ${this.offset}, buffer size is ${this.view.byteLength}`);
        }
        const bytes = new Uint8Array(this.view.buffer, this.view.byteOffset + this.offset, length);
        this.offset += length;
        return bytes;
    }
    readPascalString() {
        const length = this.readUint32LE();
        if (length === 0) {
            return '';
        }
        const bytes = this.readBytes(length);
        return (0, Util_1.decodeWindows1252)(bytes);
    }
    readPascalStringShort() {
        const length = this.readUint8();
        if (length === 0) {
            return '';
        }
        const bytes = this.readBytes(length);
        return (0, Util_1.decodeWindows1252)(bytes);
    }
    readUTF16String(length) {
        const bytes = this.readBytes(length);
        return new TextDecoder('utf-16le').decode(bytes);
    }
    seek(offset) {
        if (offset < 0 || offset > this.view.byteLength) {
            throw new Error(`[Seek_OutOfBounds] Cannot seek to offset ${offset}, buffer size is ${this.view.byteLength}`);
        }
        this.offset = offset;
    }
    skip(bytes) {
        const newOffset = this.offset + bytes;
        if (newOffset < 0 || newOffset > this.view.byteLength) {
            throw new Error(`[Skip_OutOfBounds] Cannot skip ${bytes} bytes from offset ${this.offset}, buffer size is ${this.view.byteLength}`);
        }
        this.offset = newOffset;
    }
    remaining() {
        return this.view.byteLength - this.offset;
    }
    getPosition() {
        return this.offset;
    }
    hasData() {
        return this.offset < this.view.byteLength;
    }
    getByteLength() {
        return this.view.byteLength;
    }
}
exports.BinaryReader = BinaryReader;
//# sourceMappingURL=BinaryReader.js.map